interface Condition {
    rank: "s" | "a" | "b" | "c";
    conditionTitle: string;
    conditionDescriptions: string[];
    conditionExamples: ConditionExample[];
  }
  
  interface ConditionExample {
    exampleTitle: string;
    exampleDescriptions: string[];
    exampleImageUrl: string;
  }
  
  const rankSCondition: Condition = {
    rank: "s",
    conditionTitle: "状態S [100点～90点]",
    conditionDescriptions: ["綺麗なカード"],
    conditionExamples: [
      {
        exampleTitle: "線傷（極小）90点",
        exampleDescriptions: ["傷が浅いため、光を当てると確認できるが目視では見えにくい"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-s01.jpg",
      },
      {
        exampleTitle: "凹み（極小）90点",
        exampleDescriptions: ["傷が浅いため、光を当てると確認できるが目視では見えにくい"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-s02.jpg",
      },
      {
        exampleTitle: "枠（白かけ：極小）90点",
        exampleDescriptions: ["傷が小さく、目視では見えにくい"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-s03.jpg",
      },
      {
        exampleTitle: "初期傷（裁断）90点",
        exampleDescriptions: [
          "生産時に発生する傷",
          "※横線やレリーフの加工抜けがある場合もあります",
        ],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-s04.jpg",
      },
    ],
  };
  
  const rankACondition: Condition = {
    rank: "a",
    conditionTitle: "状態A [89点～70点]",
    conditionDescriptions: ["比較的綺麗", "目立つ傷がなく、使用感があまりない"],
    conditionExamples: [
      {
        exampleTitle: "線傷（小）70点",
        exampleDescriptions: ["状態Sよりも傷が大きいが", "プレイ時には分からないレベル"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-a01.jpg",
      },
      {
        exampleTitle: "凹み（小）70点",
        exampleDescriptions: ["状態Sよりも傷が大きいが", "プレイ時には分からないレベル"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-a02.jpg",
      },
      {
        exampleTitle: "枠（白かけ：小）70点",
        exampleDescriptions: ["状態Sよりも傷が大きいが", "プレイ時には分からないレベル"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-a03.jpg",
      },
      {
        exampleTitle: "曲がり　70点",
        exampleDescriptions: [
          "カードが少し曲がっている状態",
          "スリーブに入れると傷が分からないレベル",
        ],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-a04.jpg",
      },
      {
        exampleTitle: "めくれ　70点",
        exampleDescriptions: ["少しだけカード表面の紙がめくれている"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-a05.jpg",
      },
      {
        exampleTitle: "初期傷（加工抜け）70点",
        exampleDescriptions: ["初期傷が大きく目立つ状態"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-a06.jpg",
      },
    ],
  };
  
  const rankBCondition: Condition = {
    rank: "b",
    conditionTitle: "状態B [69点～40点]",
    conditionDescriptions: [
      "ランクAと比べて目立つ傷がある",
      "複数の傷がありスリーブ越しでも分かる",
    ],
    conditionExamples: [
      {
        exampleTitle: "線傷（中：ミラー）40点",
        exampleDescriptions: [
          "一定、線傷が複数みられる状態",
          "※ミラー加工のため、傷が目立って見えますが、査定基準は原則レアリティが異なる場合でも同じ基準を適用しています",
        ],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-b01.jpg",
      },
      {
        exampleTitle: "凹み（中）40点",
        exampleDescriptions: ["状態Ａよりも大きな凹みがみられる状態"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-b02.jpg",
      },
      {
        exampleTitle: "枠（白かけ：中）40点",
        exampleDescriptions: ["状態Ａよりも目立つ白かけが見られる状態"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-b03.jpg",
      },
      {
        exampleTitle: "曲がり（シャッフル痕）40点",
        exampleDescriptions: [
          "シャッフルなどのカードプレイ時につく使用感のあるカードの曲がり",
        ],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-b04.png",
      },
      {
        exampleTitle: "複合傷　40点",
        exampleDescriptions: ["小さな折れや凹み、細かい線傷が複数に渡ってみられる状態"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-b05.png",
      },
      {
        exampleTitle: "折れ痕　40点",
        exampleDescriptions: ["カードが折れた時にシワができた状態"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-b06.jpg",
      },
    ],
  };
  
  const rankCCondition: Condition = {
    rank: "c",
    conditionTitle: "状態C [39点～0点]",
    conditionDescriptions: ["明らかに目立つ傷がある", "大会などでの使用は推奨できません"],
    conditionExamples: [
      {
        exampleTitle: "汚れ　10点",
        exampleDescriptions: [
          "小さな汚れがついている状態",
          "券面の情報に影響がなく、プレイに支障がない",
        ],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-c01.jpg",
      },
      {
        exampleTitle: "日焼け　10点",
        exampleDescriptions: [
          "日焼けによりカードが色あせてしまった状態",
          "ポケモンタイプなどが判別可能でプレイに支障がない",
        ],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-c02.jpg",
      },
      {
        exampleTitle: "枠（白かけ：大）0点",
        exampleDescriptions: ["枠全体に白かけがあり、一部目立つものがある"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-c03.jpg",
      },
      {
        exampleTitle: "水濡れ　10点",
        exampleDescriptions: [
          "ポケモンタイプなどが判別可能でプレイに支障がない",
        ],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-c04.jpg",
      },
      {
        exampleTitle: "複合傷　0点",
        exampleDescriptions: ["状態Bよりも傷が大きく、数も多くみられる状態"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-c05.jpg",
      },
      {
        exampleTitle: "折れ痕　0点",
        exampleDescriptions: ["状態Bよりも大きな折れ痕がみられる状態"],
        exampleImageUrl:"https://assets.ka-nabell.com/selling-web/pokemon/conditions/card/img-c06.jpg",
      },
    ],
  };
  
  export const conditions = [
    rankSCondition,
    rankACondition,
    rankBCondition,
    rankCCondition,
  ];
  